// En-têtes d'API avec le jeton de session, quand il y en a un.
//
// Pourquoi : les endpoints de progression (/api/stats, /api/progress,
// /api/series_done, /api/level_test) étaient identifiés par le SEUL `user_id`.
// Quiconque connaissait cet UUID pouvait lire — et écrire — la progression de
// quelqu'un d'autre. Le serveur exige désormais la session dès que l'UUID est
// revendiqué par un COMPTE ; le mode anonyme, lui, continue sans jeton (son UUID
// n'appartient à personne d'autre qu'au navigateur qui l'a tiré).
//
// D'où ce helper : joindre le jeton s'il existe, sans rien casser quand il
// n'existe pas.
const TOKEN_KEY = 'motrusse_token';

export function authHeaders(extra = {}) {
  try {
    const t = localStorage.getItem(TOKEN_KEY);
    return t ? { ...extra, Authorization: `Bearer ${t}` } : { ...extra };
  } catch {
    return { ...extra };
  }
}

export const jsonAuthHeaders = () => authHeaders({ 'Content-Type': 'application/json' });
